import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Performance-optimized rendering
const root = ReactDOM.createRoot(document.getElementById('root'));

// Use concurrent features for better performance
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for caching and offline support
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
     // console.log('SW registration successful');
  },
  onUpdate: (registration) => {
    // Optionally show update notification to user
    if (window.confirm('New version available! Reload to update?')) {
      window.location.reload();
    }
  }
});

// Performance monitoring
if ('performance' in window) {
  // Mark app start
  performance.mark('app-start');
  
  // Monitor initial render
  window.addEventListener('load', () => {
    performance.mark('app-loaded');
    performance.measure('app-load-time', 'app-start', 'app-loaded');
    
    const measure = performance.getEntriesByName('app-load-time')[0];
    console.log('App load time:', measure.duration);
  });
}

// Error boundary for production
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Web Vitals reporting (for production monitoring)
if (process.env.NODE_ENV === 'production') {
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
  }).catch(() => {
    console.log('Web Vitals not available');
  });
}